import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChildren, QueryList, ElementRef, AfterViewChecked } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { CmsBannerComponent, CmsService, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, Subject } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';
 
@Component({
  selector: 'app-fluad-video',
  standalone: false,
  templateUrl: './fluad-video.component.html',
  styleUrls: ['./fluad-video.component.scss']
})
export class FluadVideoComponent implements OnInit, AfterViewChecked, OnDestroy {
  node2: Observable<any> = this.component.data$;
  baseUrl: string;
  userLoggedIn: any;
  userInfo: any;
 
  @ViewChildren('videoPlayer') videoPlayers!: QueryList<ElementRef<HTMLVideoElement>>;
  private videosLoaded = false;
  private destroy$ = new Subject<void>();
 
  constructor(public component: CmsComponentData<CmsBannerComponent>,
    private cmsService:CmsService,
    protected config: OccConfig,
    private userInfoService:UserInfoService,
    private occConfig: OccConfig,
    private cd:ChangeDetectorRef) {this.baseUrl = this.occConfig.backend?.occ?.baseUrl || '';}
 
  ngOnInit(): void {
    this.userInfoService.userLoggedIn$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.userLoggedIn = res;
        this.videosLoaded = false;
        if (this.userLoggedIn) {
          this.userInfoService.getUserData()
            .pipe(takeUntil(this.destroy$))
            .subscribe((userData: any) => {
              if (userData) {
                this.userInfo = userData;
              }
            });
        }
 
        this.cd.detectChanges();
      });
  }
  ngAfterViewChecked(): void {
    if (!this.videosLoaded && this.videoPlayers?.length) {
      this.videoPlayers.forEach((vp) => {
        const video = vp.nativeElement;
        video.muted = true; 
        video.load();
        video.play().catch(() => {
        });
      });
      this.videosLoaded = true;
    }
  }
  getVideo(video: any): string {
    return this.config.backend?.occ?.baseUrl + video.url;
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}